import React from "react";
import Button from "../../../../Components/FormElements/Button";

const TextCodigoPago = ({ data, action, actionSecundary, loadingClick }: any) => {
  return (
    <>
      <div className="thankyou-page__texts">
        <p className="thankyou-page__title">
          ¡La cotización ha sido generada con éxito!
        </p>

        <p className="thankyou-page__subtitle">
          La cotización ha sido enviada a {data}. Comunícate con tu cliente e
          infórmale el envío del correo para que pueda realizar la firma y
          obtener el código de pago. Una vez completados se procederá con la
          emisión.
        </p>
      </div>
      <div className="thankyou-page__actions">
        <Button
          type="button"
          onClick={() => action(data)}
          className={loadingClick ? "is-loading" : ""}
        >
          Ir a cotizaciones
        </Button>
        <Button
          type="button"
          className="is-secondary"
          onClick={() => actionSecundary()}
        >
          Realizar otra cotización
        </Button>
      </div>
    </>
  );
};

export default TextCodigoPago;
